import {
    GET_NOTIFICATION_CATEGORIES,
    GET_NOTIFICATION_CATEGORIES_SUCCEEDED,
    UPDATE_PROFILE_NOTIFICATION_SETTINGS,
    GET_USER_PROFILE,
    GET_USER_PROFILE_SUCCEEDED,
    UPDATE_FAVORITE_GENRES,
    UPDATE_USER_DETAILS
} from "./types";

export const getNotificationCategories = (payload) => ({
    refresh: true,
    type: GET_NOTIFICATION_CATEGORIES,
    payload
})

export const getNotificationCategoriesSucceeded = (payload) => ({
    type: GET_NOTIFICATION_CATEGORIES_SUCCEEDED,
    payload
})

export const updateProfileNotificationSettings = (payload) => ({
    refresh: true,
    type: UPDATE_PROFILE_NOTIFICATION_SETTINGS,
    payload
})

export const getUserProfile = (payload) => ({
    refresh: true,
    type: GET_USER_PROFILE,
    payload
})

export const getUserProfileSucceeded = (payload) => ({
    type: GET_USER_PROFILE_SUCCEEDED,
    payload
})

export const updateFavoriteGenres = (payload) => ({
    refresh: true,
    type: UPDATE_FAVORITE_GENRES,
    payload
})

export const updateUserDetails = (payload) => ({
    refresh: true,
    type: UPDATE_USER_DETAILS,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/editprofile.actions.js